import { useEffect, useState } from "react";
import { alarmsApi } from "../../../services/api";
import { AlarmDetails } from "../types";
import { useNavigate } from "react-router";
import { TableRowType } from "../../../main/components/RopTable/RopTable";
import ListScreen from "../../../main/components/ListScreen";

export default function AlarmsConsultList() {
  const [loading, setLoading] = useState(true);
  const [alarms, setAlarms] = useState<AlarmDetails[]>([]);
  const [pageIndex, setPageIndex] = useState(0);
  const page = pageIndex + 1;
  const navigate = useNavigate();

  useEffect(() => {
    mount();
  }, [pageIndex, , 25]);
  const mount = async () => {
    try {
      setLoading(true);
      const response = await alarmsApi.getAlarms();
      if (response.total < page * 25) {
        setPageIndex(0);
      }
      setAlarms(response.data);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const tableRows: TableRowType[] = alarms.map((e) => {
    return {
      rowItems: [
        {
          item: e.code,
          align: "center",
          isMobile: true,
        },
        {
          item: e.name,
          align: "center",
          isMobile: true,
        },
        {
          item: e.severity,
          align: "center",
          isMobile: true,
        },
      ],
      onClick: () => {
        navigate(e.code);
      },
    };
  });

  return (
    <ListScreen
      buttonTilte="Adicionar Matriz de Alarme"
      title="Alarmes"
      onClick={() => {
        navigate("cadastrar");
      }}
      hover
      isLoading={loading}
      itemsHeaders={[
        {
          item: "Código",
          align: "center",
          isMobile: true,
        },
        {
          item: "Nome",
          align: "center",
          isMobile: true,
        },
        {
          item: "Severidade",
          align: "center",
          isMobile: true,
        },
      ]}
      itemRows={tableRows}
    />
  );
}
